import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "center-all mt-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-auto" }

import useOffCanvas from "@/components/Offcanvas/useOffCanvas";
import PixCodeComponent from "@/components/PixCodeComponent.vue";
import usePayment from "@/composables/usePayment";
import useTimeInterval from "@/composables/useTimeInterval";
import useToast from "@/composables/useToast";
import useUser from "@/composables/useUser";
import useWebSocket from "@/composables/useWebSocket";
import { EPaymentStatus, EPaymentType } from "@/enums";
import { IPaymentTransaction } from "@/interfaces";
import paths from "@/router/paths";
import webSocketService from "@/services/WebSocketService";
import { useSessionStore } from "@/store/useSessionStore";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'PixPendingPayment',
  props: {
    transactionId: {}
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const store = useSessionStore();
const { session } = store;

const { getPmTransaction, loading, savePaymentMethod } = usePayment();
const { toastSuccess } = useToast();
const { closeCanvas, canvasBackPressed } = useOffCanvas();
const { shouldStopInterval, startWatching } = useTimeInterval();
const { syncUser } = useUser();
const { subscribeToEvent, unsubscribeFromChannel } =
  useWebSocket(webSocketService);
const transaction = ref<IPaymentTransaction>();

const getTransaction = () => {
  getPmTransaction(props.transactionId, (response) => {
    transaction.value = response;
    if (response.status.value != EPaymentStatus.paid) {
      return;
    }

    shouldStopInterval.value = true;
    toastSuccess("Seu saldo foi adicionado com sucesso!");
    savePaymentMethod({ payment_type: EPaymentType.balance, card_info: null });
    syncUser();
    handleCanvasNavigation();
  });
};
const handleCanvasNavigation = () => {
  if (route.path == paths.more.root) {
    canvasBackPressed();
  } else {
    closeCanvas();
  }
};
onMounted(() => {
  loading.value = true;
  getTransaction();
  const channelName = `balance_change.${session?.id}`;
  console.log(`[PixPendingPayment] 🔌 Subscribing to channel: ${channelName}`);
  console.log(`[PixPendingPayment] 📡 Event name: balance-update`);
  console.log(`[PixPendingPayment] 👤 Session ID: ${session?.id}`);
  subscribeToEvent(
    channelName,
    "balance-update",
    (event) => {
      const oldBalance = store.currentBalance;
      const newBalance = event.user.balance;
      console.log("🔔 WebSocket: balance_change event received (PixPendingPayment)");
      console.log(`💰 Saldo anterior: R$ ${oldBalance.toFixed(2)}`);
      console.log(`💰 Saldo novo: R$ ${newBalance.toFixed(2)}`);
      console.log(`📊 Diferença: R$ ${(newBalance - oldBalance).toFixed(2)}`);
      store.updateSession({ balance: newBalance });
    }
  );
  startWatching(getTransaction);
});

onMounted(() => {
  unsubscribeFromChannel();
});

return (_ctx: any,_cache: any) => {
  const _component_AppLoading = _resolveComponent("AppLoading")!
  const _component_AppContainer = _resolveComponent("AppContainer")!

  return (_openBlock(), _createBlock(_component_AppContainer, { id: "app-pix-pending-payment" }, {
    default: _withCtx(() => [
      _createVNode(_component_AppLoading, { loading: _unref(loading) }, {
        default: _withCtx(() => [
          _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "h1 fw-bold mb" }, "Realizar pagamento", -1)),
          (transaction.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "" }, " Escaneie o QR Code abaixo com o aplicativo que deseja realizar o pagamento ou copie e cole o código ", -1)),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("img", {
                    src: transaction.value.qrcode_image,
                    id: "qr-code-img",
                    alt: ""
                  }, null, 8, _hoisted_2)
                ]),
                _createVNode(PixCodeComponent, {
                  code: transaction.value.pix_code
                }, null, 8, ["code"]),
                _createElementVNode("div", _hoisted_3, [
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col" }, [
                    _createElementVNode("h4", { class: "mb-1 fw-bold" }, "Valor")
                  ], -1)),
                  _createElementVNode("div", _hoisted_4, "R$ " + _toDisplayString(transaction.value.value), 1)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
                _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                  _createElementVNode("p", { class: "text-warning" }, [
                    _createElementVNode("small", null, [
                      _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                      _createTextVNode(" O saldo adicionado só pode ser usado para recargas no aplicativo e não pode ser estornado. ")
                    ])
                  ])
                ], -1)),
                _cache[4] || (_cache[4] = _createElementVNode("div", null, [
                  _createElementVNode("p", { class: "" }, [
                    _createElementVNode("small", null, " Ao identificar o pagamento, essa tela será atualizada automaticamente ")
                  ])
                ], -1))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

})